import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import ListAction from 'core/actions/ListAction'
import UpdateAction from 'core/actions/UpdateAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'

const { kubernetes } = ApiClient.getInstance()

export const kaapiMachineDeploymentActions = ActionsSet.make<DataKeys.KaapiMachineDeployments>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiMachineDeployments],
  cacheKey: DataKeys.KaapiMachineDeployments,
})

export const listKaapiMachineDeployments = kaapiMachineDeploymentActions.add(
  new ListAction<DataKeys.KaapiMachineDeployments>(async ({ namespace }) => {
    Bugsnag.leaveBreadcrumb('Attempting to get Kaapi MachineDeployment ', { namespace })
    return kubernetes.getAllCustomResources(DataKeys.KaapiMachineDeployments)
  })
    .addDependency(DataKeys.KaapiMachines)
    .addDependency(DataKeys.KaapiOpenStackMachineTemplates),
)

export const updateKaapiMachineDeployment = kaapiMachineDeploymentActions.add(
  new UpdateAction<
    DataKeys.KaapiMachineDeployments,
    { namespace: string; name: string; customBody: any }
  >(async ({ namespace, name, customBody }) => {
    Bugsnag.leaveBreadcrumb('Attempting to update Kaapi MachineDeployment', {
      namespace,
      customBody,
    })
    await kubernetes.patchCustomResource({
      type: DataKeys.KaapiMachineDeployments,
      name,
      body: customBody,
    })
  }),
)
